import {isString, isNil, isObject} from 'lodash';
import initializeTierOptions from 'Map/configurer/initializeTierOptions';
import {mapStyleSchemaParser} from './styleOptionInitialization/tierStyleSchemaParser';
import ThemeWrapper from './styleOptionInitialization/themeWrapper';

export default function initializeMapOptions(inputOptions) {
    const options = initializeTierOptions(inputOptions);

    if (isNil(options.container)) {
        throw new Error('"container" option is required');
    }

    if (!inputOptions.style) {
        options.theme = mapStyleSchemaParser('tomtom://vector/1/basic-main');
    } else if (isString(options.style)) {
        options.theme = mapStyleSchemaParser(options.style);
        delete options.style;
    } else if (!isObject(options.style) && !isNil(options.style)) {
        throw new Error('Style must be an object, URL or a valid resource schema');
    } else {
        options.theme = new ThemeWrapper(ThemeWrapper.TYPE.OBJECT, {
            styleObject: options.style
        });
        delete options.style;
    }

    return options;
}



// WEBPACK FOOTER //
// ./map/configurer/initializeMapOptions.js